// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2GEpI","label":"LabeledBox_label__h3BAx"};